import React from 'react';
import './ArchetypeMenu.css';
import { Tabs, Tab } from '@material-ui/core';
// import ArchetypeButton from './ArchetypeButton';

const ArchetypeMenu = (archetypes, selectArchetype, item) => {
  function handleChange(newValue) {
    selectArchetype(newValue);
  }
  return (
    <Tabs
      aria-label="tabs" className="archetypeModal-tabsHeader"
    >
      {archetypes.map((columns) => (
        <>
          {columns.map((column) => (
            <>
              {column !== '' && (
              <Tab label={column} onChange={() => handleChange(column)} className={['archetypeModal-tab', column === item ? 'selected' : '']} />
              )}
            </>
          ))}

        </>
      ))}

    </Tabs>
  );
};

export { ArchetypeMenu };
